import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { PERMISSIONS } from "../data/permissions";
import { TServiceResult } from "../Infra/TServiceResult";
import { Permission } from "../../Models/permission";
import { RouteService } from '../services/route-service/route-service';
import { PermissionService } from '../services/permission.service';
import { MessageBox } from '../message-box/message-box';


@Injectable()
export class UserGuard implements CanActivate {

    permissions: Permission[];
    constructor(private router: RouteService,
        private messageBox: MessageBox,
        private permissionService: PermissionService) {
    }
    async canActivate() {

        if (this.permissionService.IsUserLogin) {
            if (!PERMISSIONS[0]) {
                const tser = await this.getUserPermissions();
                this.permissions = tser.returnValue;
            } else {
                this.permissions = PERMISSIONS;
            }

            if (this.permissions.find(x => x.resource.resourceName === 'BranchViewAccess').aggregateAccessRight === true ||
                this.permissions.find(x => x.resource.resourceName === 'UserViewAccess').aggregateAccessRight === true) {
                // logged in so return true
                return true;
            }
        }
        if (this.permissionService.IsInBrowser)
            this.messageBox.showWarning('', 'شما به این بخش دسترسی ندارید .');
        this.router.gotoHome();
        return false;
    }


    getUserPermissions(): Promise<TServiceResult<Permission[]>> {
        return this.permissionService.getCurrentUserPermissions().toPromise();
    }

}
